import { z } from 'zod';
import { updatePasswordSchema } from './updatePassword';

export const resetPasswordSchema = updatePasswordSchema.and(
    z.object({
        token: z.string({
            message: 'Token is required',
        }),
    }),
);
